export default __webpack_public_path__ + "static/media/MECHT.2d52ded9.jpg";